import React, { useState, useEffect } from "react"
import { useAppCtx } from "lib/state"
import { appTools, cn } from "lib/utils"
import { useTemplatePreviewCtx } from "lib/units/template/preview/TemplatePreviewProvider"
import SectionHeaderRender from "../SectionHeader/SectionHeaderRender"
import { useRenderStyling } from "lib/hooks/useRenderStyling"

export default function PoliciesRender(){

  const { mode, subdomain, getFromRp, getFromMerch, getApiFeedData, getElementConfig }:any = useTemplatePreviewCtx() 
  const config = getElementConfig("policies")

  const [ preppedData, setPreppedData ] = useState<any>() 

  // john, sue => john and sue 
  // john, sue, sally => john, sue, and sally
  function formatSequentialString(arr:any[]){
    let result:string = ""
    let midjoin:string
    let endjoin:string
    if( arr.length === 1 ) return arr[0]
    if( arr.length === 2 ) return `${arr[0]} and ${arr[1]}`
    if( arr.length > 2 ){
      midjoin = ', ';
      endjoin = ', and '
    }
    arr.forEach( (item, idx) => {
      let currjoin = (idx === arr.length - 1 ) ? endjoin : midjoin 
      result += `${item}${currjoin}`
    })
    return result
  }

  function buildPolicyBlock(policy:any){
    const title = `<strong>${policy.type.charAt(0).toUpperCase()}${policy.type.substring(1)} policy:</strong>`
    const textBlock = policy.text?.length ? `<br/><span>${policy.text}</span>` : ""
    const urlBlock = policy.url?.length ? `<br/><span><a name="#">${policy.url}</a></span>` : ""
    return `<span>${title}${textBlock}${urlBlock}</span>`
  }

  function PolicyBlock({ policy }:{ policy:any }){

    const wrapperStyling = useRenderStyling("flex flex-col mt-1 mb-1", "styleObj")
    const textNormal = useRenderStyling("text-sm", "styleObj")
    const textBold = useRenderStyling("text-sm font-bold", "styleObj")

    return (
      <div {...wrapperStyling}>
        <span {...textBold}>{policy.type.charAt(0).toUpperCase()}{policy.type.substring(1)} policy:</span>
        {policy.text.length > 0 && ( <span {...textNormal}>{policy.text}</span> )}
        {policy.url > 0 && ( <span {...textNormal}>{policy.url}</span> )}
      </div>
    )
  }

  function ensureHttps(url:any) {
    if( !url ) return null
    if (/^https:\/\//.test(url)) {
      return url;  // Leave it as is
    }
  
    if (/^http:\/\//.test(url)) {
      return url.replace(/^http:\/\//, 'https://');
    }
  
    return 'https://' + url;
  }

  const prepData = () => {
    let policies:any[] = [] 
    const returnPolicy = getFromMerch("ReturnPolicy")
    const refundPolicy = getFromMerch("RefundPolicyText")
    const termsText = getFromMerch("TermsText")
    const cancellationPolicyText = getFromMerch("CancellationPolicyText")

    returnPolicy?.length && returnPolicy !== "N/A" && policies.push("return")
    refundPolicy?.length && refundPolicy !== "N/A" && policies.push("refund")
    termsText?.length && termsText !== "N/A" && policies.push("terms")
    cancellationPolicyText?.length && cancellationPolicyText !== "N/A"  && policies.push("cancel")

    const mappedPolicies = policies.map( (policy) => ({
      type: policy, 
      text: (policy === "return") ? returnPolicy
            : (policy === "refund") ? refundPolicy 
            : (policy === "terms") ? termsText 
            : (policy === "cancel") ? cancellationPolicyText 
            : "", 
      url: (policy === "return") ? ensureHttps(getFromMerch("ReturnPolicyUrl"))
            : (policy === "refund") ? ensureHttps(getFromMerch("RefundPolicyUrl"))
            : (policy === "terms") ? ensureHttps(getFromMerch("TermsUrl"))
            : (policy === "cancel") ? ensureHttps(getFromMerch("CancellationPolicyUrl")) 
            : ""
    }))
    console.log("mappedPolicies", mappedPolicies)
    setPreppedData({ 
      policies: mappedPolicies,
      types: mappedPolicies.map( (policy:any) => policy.type )
    })
  }

  const firstPStyle = useRenderStyling("block mb-0 leading-tight", "styleObj")
  const outerStyling = useRenderStyling("mm-section w-full flex flex-col mb-4", "styleObj")
  const innerStyling = useRenderStyling("w-full mt-4 pl-3", "styleObj")
  const wrapperStyling = useRenderStyling("mt-3 mb-1", "styleObj")
  const contentStyling = useRenderStyling("flex flex-col leading-tight", "styleObj")

  useEffect(() => {
    prepData()
  },[])

  if( !preppedData ) return <></>
  return (
    <div id="mm-policies" {...outerStyling}>

      <SectionHeaderRender title="Policies" />

      <div {...innerStyling}>
        <span {...firstPStyle}>We have clear {formatSequentialString(preppedData.types)} policies as seen below:</span> 
        <div {...wrapperStyling}>
          <div {...contentStyling}>
            { preppedData.policies.map( (policy:any) => (
              <PolicyBlock key={policy.type} policy={policy} />
            ))}
          </div>




            {/* dangerouslySetInnerHTML={{ __html: preppedData.policies.map( (policy:any) => buildPolicyBlock(policy) ).join('<br/>') }} 
          /> */}
        </div>
      </div>
    </div>
  )
}